import React from 'react'

export const Card = ({ children, className = '' }) => (
    <div className={`bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm p-4 min-w-0 ${className}`}>
        {children}
    </div>
)

export const COLOR_MAP = {
    teal: {
        icon: 'bg-teal-100 text-teal-600 dark:bg-teal-900/40 dark:text-teal-400',
        accent: 'border-teal-400 dark:border-teal-600',
    },
    red: {
        icon: 'bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-400',
        accent: 'border-red-400 dark:border-red-600',
    },
    blue: {
        icon: 'bg-blue-100 text-blue-600 dark:bg-blue-900/40 dark:text-blue-400',
        accent: 'border-blue-400 dark:border-blue-600',
    },
    yellow: {
        icon: 'bg-yellow-100 text-yellow-600 dark:bg-yellow-900/40 dark:text-yellow-400',
        accent: 'border-yellow-400 dark:border-yellow-600',
    },
    orange: {
        icon: 'bg-orange-100 text-orange-600 dark:bg-orange-900/40 dark:text-orange-400',
        accent: 'border-orange-400 dark:border-orange-600',
    },
    purple: {
        icon: 'bg-purple-100 text-purple-600 dark:bg-purple-900/40 dark:text-purple-400',
        accent: 'border-purple-400 dark:border-purple-600',
    },
    pink: {
        icon: 'bg-pink-100 text-pink-600 dark:bg-pink-900/40 dark:text-pink-400',
        accent: 'border-pink-400 dark:border-pink-600',
    },
    cyan: {
        icon: 'bg-cyan-100 text-cyan-600 dark:bg-cyan-900/40 dark:text-cyan-400',
        accent: 'border-cyan-400 dark:border-cyan-600',
    },
    green: {
        icon: 'bg-green-100 text-green-600 dark:bg-green-900/40 dark:text-green-400',
        accent: 'border-green-400 dark:border-green-600',
    },
    slate: {
        icon: 'bg-slate-200 text-slate-700 dark:bg-slate-700/40 dark:text-slate-300',
        accent: 'border-slate-400 dark:border-slate-500',
    },
}

export const StatCard = ({ icon, label, value, color = 'yellow' }) => {
    const c = COLOR_MAP[color] ?? COLOR_MAP.yellow
    return (
        <Card className='flex items-center gap-4'>
            <div className={`flex items-center justify-center w-14 h-14 min-w-14 rounded-full text-2xl ${c.icon}`}>
                <i className={`fa-solid ${icon}`} />
            </div>
            <div className='min-w-0'>
                <div className='text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase truncate'>{label}</div>
                <div className='text-xl font-bold text-gray-800 dark:text-gray-100 break-words'>{value}</div>
            </div>
        </Card>
    )
}

export const GroupHeader = ({ icon, title, color = 'teal' }) => {
    const c = COLOR_MAP[color] ?? COLOR_MAP.teal
    return (
        <div className={`flex items-center gap-3 pb-2 border-b-2 ${c.accent}`}>
            <div className={`flex items-center justify-center w-9 h-9 min-w-9 rounded-lg text-lg ${c.icon}`}>
                <i className={`fa-solid ${icon}`} />
            </div>
            <h3 className='text-lg font-bold text-gray-800 dark:text-gray-100'>{title}</h3>
        </div>
    )
}

export const Group = ({ icon, title, color, children }) => (
    <div className='grid gap-4 min-w-0'>
        <GroupHeader icon={icon} title={title} color={color} />
        <div className='grid gap-5 min-w-0'>
            {children}
        </div>
    </div>
)
